module.exports = __webpack_public_path__ + "static/Dafiti-f41c3144fd223fecbff8a1619116f121.png";